<template>
  <div>
    <div class="wrapper">
      <section class="wf100 subheader" style="background: var(--success)">
        <div class="container">
          <h2>خطوات تأسيس منظمة</h2>
          <ul>
            <li><router-link to="/" href="#">الرئيسية</router-link></li>
            <li>
              <router-link to="/ngo-create-steps" href="#"
                >خطوات تأسيس منظمة</router-link
              >
            </li>
            <li>إنشاء حساب</li>
          </ul>
        </div>
      </section>
      <div class="main-content">
        <b-row class="m-2">
          <b-col cols="12" xl="9">
            <b-card class="w-100 wizard-cont">
              <form-wizard
                stepSize="sm"
                color="#28c76f"
                :title="null"
                :subtitle="null"
                shape="circle"
                finish-button-text="إنهاء"
                back-button-text="السابق"
                next-button-text="التالي"
                class="mb-3"
                :validateOnBack="false"
                @on-complete="onNgoCreated"
                @on-change="updateStepInstructions"
              >
                <!-- personal info -->

                <tab-content
                  lazy
                  :before-change="validateFirstStep"
                  title="المكلف بالإجراءات"
                >
                  <validation-observer ref="accountFormValidation">
                    <signup-form ref="accountForm" v-model="accountForm" />
                  </validation-observer>
                </tab-content>

                <!-- account info -->

                <tab-content
                  lazy
                  :before-change="validateAccountInfo"
                  title="حساب المنصة الالكترونية"
                >
                  <validation-observer ref="PlatformFormValidation">
                    <platform-info-form
                      ref="platformForm"
                      v-model="platformForm"
                    />
                  </validation-observer>
                </tab-content>

                <!-- Verify Phone Number -->

                <tab-content
                  lazy
                  :before-change="verifyPhoneNumber"
                  title="تأكيد رقم الهاتف"
                  class="text-center"
                >
                  <validation-observer ref="codeField">
                    <b-form-group size="lg" label-for="verification-code">
                      <div style="font-size: large" class="">
                        لقد أرسلنا إلى :
                        <span class="text-info font-weight-bold">
                          {{ accountForm.phone_numbe }}
                        </span>
                        رسالة نصية تحوي على رمز تأكيد للتحقق من المعلومات , يرجى
                        إدخال الرمز الموجود في الرسالة في الحقل أدناه.
                      </div>
                      <b-form-group>
                        <cleave
                          dir="ltr"
                          size="xl"
                          id="verification-code"
                          v-model="verification"
                          class="form-control text-center px-auto mt-3 mx-auto form-control-lg w-25"
                          raw
                          :options="{ blocks: [5] }"
                          placeholder="XXXXX"
                        />
                      </b-form-group>
                      <img
                        style="width: 40%; height: 40%"
                        :src="
                          require('@/assets/images/illustration/sms-verification.svg')
                        "
                      />
                    </b-form-group>
                  </validation-observer>
                </tab-content>
                <!-- Ngo info -->

                <!-- <tab-content
                  lazy
                  :before-change="validateNgoInfo"
                  title="معلومات المنظمة"
                >
                  <validation-observer ref="NgoInfoForm">
                    <ngo-info-form v-model="ngoInfoForm" />
                  </validation-observer>
                </tab-content> -->

                <!-- founders info -->

                <!-- <tab-content
                  lazy
                  :before-change="validateFounders"
                  title="الأعضاء المؤسسين و مؤهلاتهم"
                >
                  <founding-members v-model="founders" />
                </tab-content> -->

                <!-- confirm info -->

                <tab-content lazy title="تأكيد المعلومات">
                  <b-alert variant="danger" show>
                    <div
                      class="alert-body text-justify"
                      style="line-height: 1.7"
                    >
                      <span class="mb-1 text-justify">
                        الرجاء التأكد من صحة المعلومات التي تم إدخالها، حيث سيتم انتقالك إلى صفحة تسجيل الدخول لتتمكن من خلالها تسجيل الدخول بالحساب الذي تم إدخاله من قبلك (اسم المستخدم، كلمة المرور) 
                       
                        <span style="font-weight: 800"
                          >وبإختيار الحقل حساب قيد التأسيس</span
                        >
                        وفي المرات القادمة يمكنك إعادة تسجيل الدخول من خلال الضغط على زر تسجيل دخول الموجود بالصفحة الرئيسية لمنصة تشارك
                      </span>
                    </div>
                  </b-alert>

                  <h6 class="my-1">معلومات الحساب</h6>
                  <hr />

                  <b-row>
                    <b-col lg="4" md="1">
                      <b-form-group label="الاسم الأول" label-for="price">
                        <b-form-input
                          id="price"
                          :value="accountForm.first_name"
                          plaintext
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="4" md="1">
                      <b-form-group label="اسم الأب" label-for="price">
                        <b-form-input
                          id="price"
                          :value="accountForm.father_name"
                          plaintext
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="4" md="1">
                      <b-form-group label="الكنية" label-for="price">
                        <b-form-input
                          id="price"
                          :value="accountForm.last_name"
                          plaintext
                        />
                      </b-form-group>
                    </b-col>

                    <b-col lg="4" md="1">
                      <b-form-group label="رقم الهاتف" label-for="price">
                        <b-form-input
                          id="price"
                          :value="accountForm.phone_number"
                          plaintext
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="5" md="1">
                      <b-form-group label="الرقم الوطني" label-for="price">
                        <b-form-input
                          id="price"
                          :value="accountForm.id_number"
                          plaintext
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="4" md="1">
                      <b-form-group label="البريد الالكتروني" label-for="price">
                        <b-form-input
                          id="price"
                          :value="accountForm.email"
                          plaintext
                        />
                      </b-form-group>
                    </b-col>
                    <b-col lg="2" md="1">
                      <b-form-group label="اسم المستخدم" label-for="price">
                        <b-form-input
                          id="price"
                          :value="platformForm.username"
                          plaintext
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </tab-content> 
              
              </form-wizard>
            </b-card>
          </b-col>
          <b-col>
            <instructions-card :slug.sync="instructionsSlug" />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import SignupForm from "@/modules/auth/components/SignupForm.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import NgoInfoForm from "../../components/NgoInfoForm.vue";
import PlatformInfoForm from "../../components/PlatformInfo.vue";
import FoundingMembers from "../../components/FoundingMembers.vue";
import * as ep from "./endpoints";
import Cleave from "vue-cleave-component";
// eslint-disable-next-line import/no-extraneous-dependencies
import "cleave.js/dist/addons/cleave-phone.us";
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BRow,
  BAlert,
  BCol,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import InstructionsCard from "@/components/InstructionsCard.vue";

export default {
  components: {
    SignupForm,
    NgoInfoForm,
    BCard,
    BCardHeader,
    BCardBody,
    FormWizard,
    FoundingMembers,
    TabContent,
    ValidationProvider,
    ValidationObserver,
    BTable,
    BRow,
    BAlert,
    BCol,
    BFormGroup,
    BFormInput,
    PlatformInfoForm,
    Cleave,
    InstructionsCard,
  },
  data() {
    return {
      accountForm: {},
      platformForm: {},
      ngoInfoForm: {
        ngo_name: "",
        fst_alt_ngo_name: "",
        sec_alt_ngo_name: "",
      },
      stepsModel: 0,
      propertyFormOptions: [
        {
          text: "عقد إيجار",
          value: "lease",
        },
        {
          text: "حق انتفاع",
          value: "usufruct",
        },
        {
          text: "عقد عارية",
          value: "loan",
        },
        {
          text: "تخصيص إداري",
          value: "administrative_allocation",
        },
      ],
      legalFormOptions: [
        {
          text: "جمعية",
          value: "association",
        },
        {
          text: "مؤسسة",
          value: "institution",
        },
        {
          text: "اتحاد",
          value: "alliance",
        },
      ],
      verification: null,
      isBack: false,
      fields: [
        {
          key: "full_name",
          label: "الاسم الثلاثي",
        },
        {
          key: "id_number",
          label: "الرقم الوطني",
        },
        {
          key: "address",
          label: "عنوان السكن",
        },
        {
          key: "qualifications",
          label: "المؤهل العلمي",
        },
        {
          key: "jobs",
          label: "العمل",
        },
        {
          key: "phone_number",
          label: "رقم الهاتف",
        },
      ],
      founders: [
        {
          name: "",
          id_number: "",
          address: "",
          qualifications: "",
          jobs: "",
          phone_number: "",
        },
      ],
    };
  },
  methods: {
    ...mapActions("NgoHome/Signup", ["proceedToNextStep", "verifyCode"]),
    ...mapActions("Auth", ["logout"]),
    async onNgoCreated() {
      // await this.logout();
      this.$router.push({ name: "auth-login" });
    },
    updateStepInstructions(event, index) {
      this.stepsModel = index;
    },
    async verifyPhoneNumber() {
      return new Promise(async (resolve, reject) => {
        await this.verifyCode(this.verification)
          .then(() => {
            resolve(true);
          })
          .catch(() => {
            reject(false);
          });
      });
    },
    validateFirstStep() {
      return new Promise(async (resolve, reject) => {
        await this.$refs.accountFormValidation
          .validate()
          .then(async (success) => {
            if (success) {
              await this.proceedToNextStep({
                form: this.accountForm,
                ep: ep.ZERO_STEP,
              })
                .then(() => {
                  resolve(true);
                })
                .catch(() => {
                  reject(false);
                });
            } else {
              reject(false);
            }
          });
      });
    },
    validateAccountInfo() {
      return new Promise(async (resolve, reject) => {
        await this.$refs.PlatformFormValidation.validate().then(
          async (success) => {
            if (success) {
              await this.proceedToNextStep({
                form: this.platformForm,
                ep: ep.FIRST_STEP(this.firstId),
              })
                .then(() => {
                  // var backBtn = document.querySelector(".wizard-footer-left");
                  // backBtn.classList.add("removed");
                  resolve(true);
                })
                .catch(() => {
                  reject(false);
                });
            } else {
              reject(false);
            }
          }
        );
      });
    },
    validateNgoInfo() {
      return new Promise(async (resolve, reject) => {
        await this.$refs.NgoInfoForm.validate().then(async (success) => {
          if (success) {
            await this.proceedToNextStep({
              form: {
                ...this.ngoInfoForm,
                est_account_id: this.id,
              },
              ep: ep.SECOND_STEP,
            })
              .then(() => {
                resolve(true);
              })
              .catch(() => {
                reject(false);
              });
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },
    validateFounders() {
      this.founders = this.founders.filter((el) => Object.keys(el).length >= 5);
      return new Promise(async (resolve, reject) => {
        await this.proceedToNextStep({
          form: {
            members: this.founders,
            est_ngo_id: this.ngoId,
          },
          ep: ep.THIRD_STEP,
        })
          .then(() => {
            resolve(true);
          })
          .catch(() => {
            reject(false);
          });
      });
    },
  },
  computed: {
    ...mapGetters("NgoHome/Signup", ["id", "ngoId", "firstId"]),
    ...mapGetters("gov", {
      governorates: "options",
    }),
    ...mapGetters("class", {
      classifications: "options",
    }),
    instructionsSlug() {
      return this.stepsModel === 0
        ? "est-creation-first-step"
        : this.stepsModel === 1
        ? "est-creation-second-step"
        : this.stepsModel === 2
        ? "est-creation-third-step"
        : this.stepsModel === 3
        ? "est-creation-forth-step"
        : this.stepsModel === 4
        ? "est-creation-fifth-step"
        : "est-creation-last-step";
    },
  },
};
</script>

<style lang="scss">
.wizard-cont {
  .wizard-icon {
    font-style: normal;
  }
  .wizard-footer-left {
    display: none;
  }
  .vue-form-wizard .wizard-nav-pills a,
  .vue-form-wizard .wizard-nav-pills li {
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>
